import { render } from "./mobile_nav.vue?vue&type=template&id=84877198"
import script from "./mobile_nav.js?vue&type=script&lang=js&external"
export * from "./mobile_nav.js?vue&type=script&lang=js&external"

import "./mobile_nav.vue?vue&type=style&index=0&id=84877198&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__